import React, { Component } from "react";
import Link, { navigateTo } from "gatsby-link";
import styled from "styled-components";
import MediaQuery from "react-responsive";
import HamburgerMenu from "react-hamburger-menu";
import OutsideClickHandler from "react-outside-click-handler";
import ScrollLock from "react-scrolllock";

import Logo from "../../assets/icons/Logo/light.svg";
import Icon from "../UI/Icon";

import baseStyles from "../../styles/baseStyles";

const MenuItem = styled.li`
  display: flex;
  align-items: center;
  :not(:last-of-type) {
    margin-right: 4rem;
  }
  @media screen and (max-width: 48em) {
    :not(:last-of-type) {
      margin-right: 2rem;
    }
  }
  > a {
    color: ${baseStyles.color.lightGray};
    font-family: Lato;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    text-align: center;
    font-size: 0.9375rem;
    font-weight: 400;
    text-decoration: none;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4rem;
  width: 100%;
  position: relative;
  z-index: 500;
  background: transparent;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 64rem;
  width: 100%;
  @media screen and (max-width: 64em) {
    padding: 0 2rem;
  }
  @media screen and (max-width: 20em) {
    padding: 0 1rem;
  }
`;

const BrandLogo = styled(Link)`
  display: flex;
  align-items: center;
`;

const HeaderMenu = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  padding: 0;
`;

const Menu = styled.nav`
  position: fixed;
  height: 100%;
  width: 14rem;
  top: 0;
  right: 0;
  background: ${baseStyles.color.blueGradient};
  box-shadow: ${baseStyles.layers.l5};
  padding: 2rem;
  display: flex;
  flex-direction: column;
  transform: ${props => (props.isOpen ? `translateX(0)` : `translateX(20rem)`)};
  transition: all 0.4s ease;
  z-index: 10000;
`;

const SideMenuItem = styled(Link)`
  font-family: Lato;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-align: left;
  font-size: 1rem;
  font-weight: 400;
  text-decoration: none;
  color: white;
  margin-bottom: 1.25rem;
`;

class Header extends Component {
  state = {
    menuItems: [
      {
        name: "Home",
        route: "/"
      },
      {
        name: "Jobs",
        route: "/jobs"
      },
      {
        name: "Events",
        route: "/events"
      },
      {
        name: "Nordics",
        route: "/nordics"
      },
      {
        name: "About",
        route: "/about"
      }
    ],
    isOpen: false
  };

  onMenuItemClick = route => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
    navigateTo(route);
  };

  handleClick = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  onOutsideClick = () => {
    if (this.state.isOpen) {
      this.handleClick();
    }
  };

  renderMenu() {
    return this.state.menuItems.map(({ name, route }) => {
      return (
        <MenuItem key={name}>
          <Link
            to={route}
            exact={route === "/"}
            activeStyle={{ color: baseStyles.color.primary }}
          >
            {name}
          </Link>
        </MenuItem>
      );
    });
  }
  render() {
    return (
      <HeaderWrapper>
        <HeaderContent>
          <BrandLogo to="/">
            <Icon iconRef={Logo} size={3} />
          </BrandLogo>
          <MediaQuery query="(min-width: 426px)">
            <HeaderMenu>{this.renderMenu()}</HeaderMenu>
          </MediaQuery>
          <MediaQuery query="(max-width: 425px)">
            <HamburgerMenu
              isOpen={this.state.isOpen}
              menuClicked={this.handleClick}
              width={20}
              height={14}
              strokeWidth={2}
              rotate={0}
              color={baseStyles.color.lightGray}
              borderRadius={1}
              animationDuration={0.5}
            />
          </MediaQuery>
        </HeaderContent>
        <MediaQuery query="(max-width: 425px)">
          <OutsideClickHandler onOutsideClick={this.onOutsideClick}>
            <Menu isOpen={this.state.isOpen}>
              {this.state.isOpen && <ScrollLock />}
              <div style={{ alignSelf: "flex-end", marginBottom: "2rem" }}>
                <HamburgerMenu
                  isOpen={this.state.isOpen}
                  menuClicked={this.handleClick}
                  width={20}
                  height={14}
                  strokeWidth={2}
                  rotate={0}
                  color="#fff"
                  borderRadius={1}
                  animationDuration={0.5}
                />
              </div>
              {this.state.menuItems.map(({ name, route }) => (
                <SideMenuItem
                  exact={route === "/"}
                  key={name}
                  to={route}
                  activeStyle={{ textDecoration: "underline" }}
                  onClick={() => this.onMenuItemClick(route)}
                >
                  {name}
                </SideMenuItem>
              ))}
            </Menu>
          </OutsideClickHandler>
        </MediaQuery>
      </HeaderWrapper>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js